import React, { Fragment, useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { LayoutContext } from "../layout";
import { subTotal, quantity, totalCost } from "../partials/Mixins";
import { cartListProduct } from "../partials/FetchApi";
import { fetchData } from "./Action";

const apiURL = process.env.REACT_APP_API_URL;


// Composant pour sélectionner la zone de livraison
const ZoneSelector = ({ selectedZone, setSelectedZone, selectedSubZone, setSelectedSubZone, setDeliveryPrice }) => {
  const zones = [
    { name: "Dakar Centre", sub: ["Plateau", "Médina", "Geule Tapée", "Point E", "UCAD","Fann"], price: 2000 },
    { name: "Almadies", sub: ["Almadies", "Ngor", "Ouakam", "Yoff"], price: 3500 },
    { name: "HLM / Foire", sub: ["HLM", "Grand Dakar", "Castor"], price: 2500 },
    { name: "Mermoz / Liberté", sub: ["Liberté", "Mermoz", "Sacré-Cœur", "Cité Keur Gorgui"], price: 3000 },
    { name: "Pikine / Thiaroye", sub: ["Pikine Est", "Pikine Ouest", "Thiaroye"], price: 3000 },
    { name: "Guédiawaye", sub: ["Ndiarème","Guédiawaye","Yeumbeul","Malika", "Golf Sud"], price: 2500 },
    { name: "Rufisque / Diamniadio", sub: ["Rufisque Ville", "Sangalkam", "Bargny", "Diamniadio", "Sebikhotane"], price: 3000 },
    { name: "Keur Massar", sub: ["Keur Massar", "Sendou", "Dibida", "Bambilor"], price: 3000 },
  
    
    {
      name: "Thiès ",
      sub: ["Thiès Ville", "Tivaouane", "Mbour", "Saly Portudal", "Joal-Fadiouth", "Khombole", "Toubab Dialaw"], price: 3200 
    },
    {
      name: "Saint-Louis",
      sub: ["Saint-Louis Ville", "Richard-Toll", "Dagana", "Podor"],price: 5500
    },
    {
      name: "Louga",
      sub: ["Louga Ville", "Kébémer", "Linguère"],price: 4900
    },
    {
      name: "Diourbel",
      sub: ["Diourbel Ville", "Mbacké", "Touba", "Bambey"],price: 3900
    },
    {
      name: "Kaolack",
      sub: ["Kaolack Ville", "Ndiébel", "Gandiaye", "Koungheul"],price: 4900
    },
    {
      name: "Fatick",
      sub: ["Fatick Ville", "Foundiougne", "Gossas", "Birkelane"],price: 4800
    },
    {
      name: "Ziguinchor",
      sub: ["Ziguinchor Ville", "Bignona", "Oussouye", "Cap Skirring"],price: 7900
    },
    {
      name: "Kolda",
      sub: ["Kolda Ville", "Velingara", "Médina Yoro Foulah"],price: 8900
    },
    {
      name: "Tambacounda",
      sub: ["Tambacounda Ville", "Goudiry", "Kédougou", "Bakel"],price: 7900
    },
    {
      name: "Kaffrine",
      sub: ["Kaffrine Ville", "Malem Hodar", "Koungheul"],price: 5900
    },
    {
      name: "Sédhiou",
      sub: ["Sédhiou Ville", "Goudomp", "Marsassoum"],price: 7800
    },
    { name: "France", sub: ["Paris", "Lyon", "Marseille", "Toulouse", "Nice", "Nantes", "Strasbourg", "Montpellier", "Bordeaux", "Lille"],price: 50000 },
    { name: "Espagne", sub: ["Madrid", "Barcelone", "Séville", "Valence", "Malaga", "Bilbao"],price: 55000 },
    { name: "Canada", sub: ["Montréal", "Toronto", "Vancouver", "Québec"],price: 65000 },
    { name: "USA", sub: ["New York", "Los Angeles", "Chicago", "Houston", "Miami"],price: 65000 },
    { name: "Autres Pays d'Afrique", sub: ["Abidjan (Côte d'Ivoire)", "Bamako (Mali)", "Conakry (Guinée)", "Nouakchott (Mauritanie)", "Casablanca (Maroc)"],price: 50000 },
    { name: "Autre", sub: ["Autre Localité / Ville"],price: 5000 },
  ];

  const currentZone = zones.find((z) => z.name === selectedZone);

  const handleZoneChange = (zone) => {
    setSelectedZone(zone.name);
    setSelectedSubZone("");
    setDeliveryPrice(zone.price);
  };

  return (
    <div className="my-4">
      <h3 className="text-lg font-semibold mb-2">Choisissez votre localité :</h3>
      <div className="flex flex-wrap gap-2 mb-3">
        {zones.map((zone, idx) => (
          <button
            key={idx}
            onClick={() => handleZoneChange(zone)}
            className={`px-3 py-1 rounded-md font-medium transition-colors ${
              selectedZone === zone.name
                ? "bg-blue-800 text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
            }`}
          >
            {zone.name}
          </button>
        ))}
      </div>

      {currentZone && currentZone.sub.length > 0 && (
        <div className="mb-2">
          <h4 className="text-md font-medium mb-1">Découpage :</h4>
          <select
            value={selectedSubZone}
            onChange={(e) => setSelectedSubZone(e.target.value)}
            className="border px-3 py-1 rounded-md w-full md:w-auto"
          >
            <option value="">-- Choisir un découpage --</option>
            {currentZone.sub.map((sub, idx) => (
              <option key={idx} value={sub}>{sub}</option>
            ))}
          </select>
        </div>
      )}

      <p className="mt-2 text-gray-700">
        Localité sélectionnée :{" "}
        <span className="font-semibold">
          {selectedZone} {currentZone ? `(${currentZone.price} F)` : ""}
        </span>
        <br />
        {selectedSubZone && (
          <>
            Sous-zone sélectionnée : <span className="font-semibold">{selectedSubZone}</span>
          </>
        )}
      </p>
    </div>
  );
};

export const CheckoutComponent = () => {
  const history = useHistory();
  const { data, dispatch } = useContext(LayoutContext);

  const [selectedZone, setSelectedZone] = useState("");
  const [selectedSubZone, setSelectedSubZone] = useState("");
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [state, setState] = useState({
    address: "",
    phone: "",
    countryCode: "+221",
    phoneNumber: "",
    error: false,
    success: false,
  });
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData(cartListProduct, dispatch);
  }, []);

  // La redirection est désormais déclenchée par le bouton "OK" du popup

  const totalWithDelivery = totalCost(data.cartProduct) + deliveryPrice;

  const handleOrder = async () => {
    if (!selectedZone) {
      alert("Veuillez sélectionner une zone de livraison.");
      return;
    }
  
    if (!state.address || !state.phoneNumber) {
      alert("Veuillez renseigner une precision sur l'adresse et le numéro de téléphone.");
      return;
    }
  
    const stored = JSON.parse(localStorage.getItem("jwt"));
    const userId = stored?.user?._id;
  
    if (!userId) {
      alert("Connectez-vous pour passer une commande.");
      return;
    }
  
    if (!data.cartProduct || data.cartProduct.length === 0) {
      alert("Votre panier est vide.");
      return;
    }
  
    const allProduct = data.cartProduct.map(p => {
      const qty = quantity(p._id);
      return { id: p._id, quantity: qty > 0 ? qty : 1 }; // assure quantité minimum 1
    });
  
    const rawCart = JSON.parse(localStorage.getItem("cart")) || [];
    const cartTotal = rawCart.reduce((sum, c) => sum + (c.quantity * c.price), 0);

    const orderData = {
      allProduct, // tableau {id, quantity}
      user: userId,
      amount: cartTotal, // montant hors livraison (stocké côté serveur)
      deliveryPrice: deliveryPrice,
      address: {
        zone: selectedZone,
        subZone: selectedSubZone || "",
        details: state.address,
      },
      phone: state.phoneNumber,
    };
  
    console.log("=== Order Data Sent ===");
    console.log(orderData);
  
    setLoading(true);
    try {
      const response = await axios.post(`${apiURL}/api/order/create-order`, orderData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.status === 201 || (response.data && (response.data.order || response.data.success))) {
        // Assurer que l'utilisateur voit le popup en haut de page
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
        // Marquer qu'une commande vient d'être complétée pour empêcher la redirection du guard
        localStorage.setItem("orderJustCompleted", "1");
        setShowPopup(true);
  // Purge panier + état (conserver la clé avec un tableau vide pour éviter JSON.parse null)
  localStorage.setItem("cart", JSON.stringify([]));
  localStorage.removeItem("quantity");
        dispatch({ type: "cartProduct", payload: [] });
        dispatch({ type: "cartTotalCost", payload: 0 });
        dispatch({ type: "orderSuccess", payload: true });
      } else {
        alert(response.data.message || response.data.error || "Erreur lors de la création de la commande");
      }
    } catch (err) {
      if (err.response) {
        console.error("Status:", err.response.status);
        console.error("Data:", err.response.data);
        alert(`Erreur serveur: ${err.response.data.error || err.response.data.message || JSON.stringify(err.response.data)}`);
      } else if (err.request) {
        console.error("No response received:", err.request);
        alert("Aucune réponse du serveur");
      } else {
        console.error("Erreur Axios:", err.message);
        alert(`Erreur Axios: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };
  

  if (data.loading) {
    return (
      <div className="flex items-center justify-center h-screen">
       <img
          className="w-12 h-12 animate-spin text-yellow-600"
          fill="none"
          stroke="currentColor"
           src="/images/favicon.png"
        />
        Chargement de la page
      </div>
    );
  }

  return (
    <Fragment>
      <section className="mx-4 mt-20 md:mx-12 md:mt-32 lg:mt-24">
        <div className="text-2xl mx-2 mb-4">Validation Commande</div>

        <div className="flex flex-col md:flex md:space-x-2 md:flex-row">
          <div className="md:w-1/2">
            <CheckoutProducts products={data.cartProduct} />
          </div>

          <div className="w-full order-first md:order-last md:w-1/2">
            <ZoneSelector
              selectedZone={selectedZone}
              setSelectedZone={setSelectedZone}
              selectedSubZone={selectedSubZone}
              setSelectedSubZone={setSelectedSubZone}
              setDeliveryPrice={setDeliveryPrice}
            />

            <div className="flex flex-col py-2">
              <label htmlFor="address" className="pb-2">Précision sur la livraison</label>
              <input
                value={state.address}
                onChange={(e) => setState({ ...state, address: e.target.value, error: false })}
                type="text"
                id="address"
                className="border px-4 py-2"
                placeholder="..."
              />
            </div>

            <div className="flex flex-col py-2 mb-2">
              <label htmlFor="phone" className="pb-2">Téléphone</label>
              <div className="flex space-x-2">
                <select
                  value={state.countryCode || "+221"}
                  onChange={(e) => setState({ ...state, countryCode: e.target.value })}
                  className="border px-1 py-1"
                >
                  <option value="+221">SN (+221)</option>
                  <option value="+225">CIV (+225)</option>
                  <option value="+220">GAM (+220)</option>
                  <option value="+212">MAR (+212)</option>
                  <option value="+33">FR (+33)</option>
                  <option value="+34">ESP (+34)</option>
                  <option value="+1">USA (+1)</option>
                  <option value="+44">UK (+44)</option>
                </select>
                <div className="flex flex-col w-full">
  <input
    value={state.phoneNumber || ""}
    onChange={(e) => {
      const value = e.target.value;

      // Regex international basique : + ou chiffre, 8 à 15 chiffres
      const phoneRegex = /^\d{8,15}$/;

      setState({
        ...state,
        phoneNumber: value,
        error: !phoneRegex.test(value) && value !== "", // true si mauvais format
      });
    }}
    type="tel"
    id="phone"
    className={`border px-4 py-2 flex-1 rounded ${
      state.error ? "border-red-500" : "border-gray-300"
    }`}
    placeholder="Numéro..."
  />

  {state.error && (
    <p className="text-red-500 text-sm mt-1">
      Numéro de téléphone invalide
    </p>
  )}
</div>

              </div>
            </div>

            <button
              onClick={handleOrder}
              disabled={loading}
              className="w-full px-4 py-2 text-center text-white font-semibold cursor-pointer mt-4"
              style={{ background: "#1E344D" }}
            >
              {loading ? "Validation en cours..." : "Valider la commande"}
            </button>
            <span className="text-blue-600 text-sm">
            La livraison dans une localité sénégalaise se fait dans les 48h.
            </span>
            <div className="mt-2 text-right font-semibold">
              Total (commande + livraison) : {totalWithDelivery} F CFA
            </div>
          </div>
        </div>
      </section>

      {showPopup && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50"
          style={{ backgroundColor: "rgba(0,0,0,0.25)" }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="order-success-title"
        >
          <div className="border bg-white border-green-300 rounded-md shadow-xl p-6 max-w-sm w-full m-4 text-center transform scale-100 opacity-100 transition" aria-live="polite">
            <div className="flex justify-center mb-3">
              {/* Icône check success */}
              <svg
                className="w-12 h-12 text-green-600"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 id="order-success-title" className="text-2xl font-semibold text-green-800 mb-2">Commande enregistrée !</h3>
            <p className="text-gray-700 mb-2 text-sm">
              Nous allons vous contacter pour la suite.
            </p>
            <p className="text-gray-500 text-xs mb-4">Cliquez sur OK pour continuer.</p>
            <button
              onClick={() => {
                setShowPopup(false);
                // Nettoyer le flag du guard
                localStorage.removeItem("orderJustCompleted");
                // Aller directement à l'accueil
                history.push("/");
              }}
              className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition"
            >
              OK
            </button>
          </div>
        </div>
      )}

    </Fragment>
  );
};

const CheckoutProducts = ({ products }) => {
  const history = useHistory();

  return (
    <Fragment>
      <div className="grid grid-cols-2 md:grid-cols-1">
        {products && products.length > 0 ? (
          products.map((product, index) => (
            <div key={index} className="col-span-1 m-2 md:py-6 md:border-t md:border-b md:my-2 md:mx-0 md:flex md:items-center md:justify-between">
              <div className="md:flex md:items-center md:space-x-4">
                <img
                  onClick={() => history.push(`/products/${product._id}`)}
                  className="cursor-pointer h-25 md:w-full object-cover object-center"
                  src={`${apiURL}/uploads/products/${product.pImages[0]}`}
                  alt={product.pName}
                />
                <div className="text-lg md:ml-6 truncate">{product.pName}</div>
                <div className="md:ml-6 font-semibold text-gray-600 text-sm">Prix : {product.pPrice} F CFA</div>
                <div className="md:ml-6 font-semibold text-gray-600 text-sm">Quantité : {quantity(product._id)}</div>
                <div className="font-semibold text-gray-600 text-sm">Sous-Total : {subTotal(product._id, product.pPrice)} F</div>
              </div>
            </div>
          ))
        ) : (
          <div>Aucun produit trouvé pour la commande.</div>
        )}
      </div>
    </Fragment>
  );
};

export default CheckoutComponent;
